import { Container, Grid, Slide, Tooltip } from "@material-ui/core";
import {
  ArrowDownward,
  ArrowUpward,
  Visibility,
  Search,
  Receipt,
  ArrowBack,
  History,
} from "@material-ui/icons";
import { Pagination } from "@material-ui/lab";
import { useCallback, useRef, useEffect, useState, useContext } from "react";
import Loading from "../../../components/basics/Loading";
import SelectErp from "../../../components/basics/SelectErp";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import Btn from "../../../components/buttons/Btn";
import HeaderModule from "../../../components/header/HeaderModule";
import { formatDate } from "../../../utils/formatDate";
import MaskService from "../../../utils/mask/maskService";
import ModalSearch from "./children/ModalSearch";
import useConciliacaoBancariaController from "./controllers/ConciliacaoBancariaController";
import {
  ButtonsContainer,
  CardBody,
  ContainerRow,
  CustomDiv,
  ExtractContainter,
  IconButtonStyled,
  IgnoreButton,
  IndicatorStyled,
  InfoButton,
  PaginationContainer,
  Separator,
  StatusBar,
  GridTitleSeparator,
} from "./styles/style";

import Card from "./../../../components/cards/Card";
import SimpleMenuErp from "./../../../components/basics/SimpleMenuErp";
import ModalVisualization from "./children/ModalVisualization";
import { notify } from "./../../../utils/notify";
import { useHistory } from "react-router-dom";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import {
  ConciliacaoBancariaContext,
  ConciliacaoBancariaContextProvider,
} from "./contexts/ConciliacaoBancariaContext";
import Swal from "sweetalert2";
import {
  openFinanceConciliation,
  vincularAgencia,
} from "../../../repositories/qerpapi/erp/financeiro/ConciliacaoBancariaRepository";
import ModalLogs from "./children/ModalLogs";
import { findTitleLog } from "../../../repositories/qerpapi/v3/log/financeiro/conciliacao/BancariaRepository";
import ModalMismatchValue from "./children/ModalMismatchValue";
import { GlobalVariables } from "../../../GlobalVariables";

const ROWS_PER_PAGE = 10;

const STATUS = {
  pendente: {
    color: "#fc9d03",
    title: "Pendente",
  },
  naoconciliado: {
    color: "#858585",
    title: "Não Conciliado",
  },
  ignorado: {
    color: "#FA8072",
    title: "Ignorado",
  },
  naoconfirmado: {
    color: "#deb887 ",
    title: "Não Confirmado",
  },
  conciliado: {
    color: "#39A388",
    title: "Conciliado",
  },
};

const INITIAL_STATE = { label: "Todos", value: "" };

const View = ({ location }) => {
  const { push, goBack } = useHistory();
  const { queryParams } = useContext(QueryParamsContext);
  const {
    fileId,
    setFileId,
    loading,
    setLoading,
    bankAccount,
    setBankAccount,
    bankAccountsList,
    setBankAccountsList,
    setAlertCategory,
    historicVisualization,
    conciliationType,
    setConciliationType,
    setHistoricVisualization,
    openFinanceConciliationLoading,
    setOpenFinanceConciliationLoading,
  } = useContext(ConciliacaoBancariaContext);
  const {
    bankExtractFilterList,
    statusesList,
    // erpList,
    categoriesList,
    handleChangeSelect,
    executeScroll,
    makeTransactionsArray,
    filterTransactions,
    confirmateConciliations,
    makeConciliation,
    cancelConciliation,
    ignoreConciliation,
    cancelIgnoreConciliation,
  } = useConciliacaoBancariaController();

  // Filtros
  const [bankExtract, setBankExtract] = useState(INITIAL_STATE);
  const [status, setStatus] = useState(INITIAL_STATE);
  const [category, setCategory] = useState(INITIAL_STATE);

  const [transactions, setTransactions] = useState([]);
  const [hasBank, setHasBank] = useState(false);

  const FILTERS = {
    extract: bankExtract,
    status,
    // movimentations,
    category,
  };

  const [indicators, setIndicators] = useState([
    {
      label: "Lançamentos Importados",
      counterState: 0,
    },
    {
      label: "Pendentes",
      counterState: 0,
    },
    {
      label: "Não Confirmados",
      counterState: 0,
    },

    {
      label: "Não Conciliados",
      counterState: 0,
    },
    {
      label: "Ignorados",
      counterState: 0,
    },
    {
      label: "Conciliados",
      counterState: 0,
    },
  ]);

  const [pageProp, setPageProp] = useState(1);

  const [initialDate, setInitialDate] = useState(location.state?.dates?.start);

  const [finalDate, setFinalDate] = useState(location.state?.dates?.end);

  const separatorRef = useRef(null);

  const handlePaginationChange = (e, page) => {
    setPageProp(page);
    executeScroll(separatorRef);
  };

  const doConciliation = async () => {
    if (indicators[4].counterState) {
      await Swal.fire({
        icon: "question",
        text: "Existem lançamentos ignorados. Deseja concluir a conciliação mesmo assim?",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          confirmateConciliations();
        }
      });
    } else {
      confirmateConciliations();
    }
  };

  useEffect(() => {
    if (location?.state?.bankAccounts) {
      setBankAccountsList(location?.state?.bankAccounts);
    }
  }, [location?.state?.bankAccounts, setBankAccountsList]);

  useEffect(() => {
    if (location?.state?.historicVisualization) {
      setHistoricVisualization(location?.state?.historicVisualization);
    }
  }, [location?.state?.historicVisualization, setHistoricVisualization]);

  useEffect(() => {
    if (location?.state?.linkedBank && location?.state?.bankAccounts) {
      let findBank = location?.state?.bankAccounts.find(
        (bank) => bank.id === location?.state?.linkedBank
      );

      setBankAccount(findBank || null);
      setHasBank(true);
    }

    if (location?.state?.conciliationType) {
      setConciliationType(location?.state?.conciliationType);
    }
  }, [
    location?.state?.linkedBank,
    location?.state?.bankAccounts,
    setBankAccount,
    setHasBank,
    location?.state?.conciliationType,
    setConciliationType,
  ]);

  useEffect(() => {
    if (!location.state) {
      push(
        `conciliacaoupload?empresa_cnpj=${queryParams.empresa_cnpj}&empresa_id=${queryParams.empresa_id}&usuario_id=${queryParams.usuario_id}`
      );
      return notify("Nenhum arquivo importado.");
    } else {
      setFileId(location.state.file_ofx?.id);
      setTransactions(makeTransactionsArray(location?.state?.transactions));
    }
  }, [
    location.state,
    push,
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    queryParams.usuario_id,
    setFileId,
    makeTransactionsArray,
  ]);

  useEffect(() => {
    setPageProp(1);
  }, [bankExtract, status, category]);

  useEffect(() => {
    setIndicators([
      {
        label: "Lançamentos Importados",
        counterState: transactions?.length,
      },
      {
        label: "Pendentes",
        counterState: transactions?.filter((e) => e.status === "pendente")
          .length,
      },
      {
        label: "Não Confirmados",
        counterState: transactions?.filter((e) => e.status === "naoconfirmado")
          .length,
      },
      {
        label: "Não Conciliados",
        counterState: transactions?.filter((e) => e.status === "naoconciliado")
          .length,
      },
      {
        label: "Ignorados",
        counterState: transactions?.filter((e) => e.status === "ignorado")
          .length,
      },
      {
        label: "Conciliados",
        counterState: transactions?.filter((e) => e.status === "conciliado")
          .length,
      },
    ]);
  }, [transactions]);

  useEffect(() => {
    setAlertCategory(category?.value || "");
  }, [category, setAlertCategory]);

  const makeAction = useCallback(
    (action, body) =>
      ({
        pendente: () => makeConciliation(body),
        naoconfirmado: () => cancelConciliation(body),
        ignorado: () => ignoreConciliation(body),
        desfazer: () => cancelIgnoreConciliation(body),
      }[action]),
    [
      makeConciliation,
      cancelConciliation,
      ignoreConciliation,
      cancelIgnoreConciliation,
    ]
  );

  const handleItemActions = useCallback(
    async ({ action, content, body }, id, setItem = () => {}) => {
      var element;
      switch (action) {
        case "changeStatus":
          const callback = await makeAction(content, body)();

          if (!callback?.success) return;

          let newStatus = content;
          if (newStatus === "desfazer") {
            if (!body?.movimentacao_contas?.length) newStatus = "naoconciliado";
            else newStatus = "naoconfirmado";
          }

          setTransactions((current) => {
            current = current.map((item) => {
              if (item.id === id) {
                element = {
                  ...item,
                  status: newStatus,
                };
                return element;
              } else return item;
            });

            return current;
          });

          break;

        case "edit":
          setTransactions((current) => {
            current = current.map((item) => {
              if (item.id === id) {
                element = {
                  ...item,
                  pending: content,
                  status:
                    item.status !== "naoconciliado"
                      ? item.status
                      : "naoconfirmado",
                  ...(!content.length && { status: "naoconciliado" }),
                  ...(content.length &&
                    item.status === "ignorado" && { status: "naoconfirmado" }),
                };
                return element;
              } else return item;
            });

            return current;
          });
          break;

        default:
          console.error("Erro!");
          break;
      }

      setItem(element);
    },
    [makeAction]
  );

  const handleSetBankAccount = async (account) => {
    if (!account?.id) return;

    Swal.fire({
      icon: "question",
      text: "Após selecionar a conta bancária, não será possível desfazer essa ação. Deseja continuar?",
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);

          const sendBody = {
            empresa_cnpj: queryParams.empresa_cnpj,
            arquivo_ofx_id: fileId,
            agencia_id: account.id,
          };

          const response = await vincularAgencia({
            empresa_cnpj: queryParams.empresa_cnpj,
            empresa_id: queryParams.empresa_id,
            body: sendBody,
          });

          if (!response.success) {
            setBankAccount(null);
            return notify("Erro ao registrar a conta bancária.");
          }

          setBankAccount(account);
          setHasBank(true);
        } catch (e) {
          console.error(e);
          notify("Erro ao registrar a conta bancária.");
          setBankAccount(null);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleOpenFinanceConciliation = useCallback(async () => {
    if (!initialDate || !finalDate) return;

    try {
      setOpenFinanceConciliationLoading(true);
      const callbackPending = await openFinanceConciliation({
        empresa_cnpj: queryParams.empresa_cnpj,
        agencia_id: location?.state?.linkedBank,
        start_date: initialDate,
        end_date: finalDate,
        empresa_id: queryParams.empresa_id,
      });

      if (!callbackPending.success)
        return notify("Erro ao buscar títulos pendentes!");

      setTransactions(makeTransactionsArray(callbackPending.data.transactions));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setOpenFinanceConciliationLoading(false);
    }
  }, [
    finalDate,
    initialDate,
    location?.state?.linkedBank,
    makeTransactionsArray,
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    setOpenFinanceConciliationLoading,
  ]);

  useEffect(() => {
    if (location?.state?.conciliationType !== "openFinance") return;

    handleOpenFinanceConciliation();
  }, [location?.state?.conciliationType]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <HeaderModule
        title="CONCILIAÇÃO BANCÁRIA"
        videoId={GlobalVariables.screenVideosIds.conciliacaoBancaria}
        receivedChild={
          <Grid item container xs justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Tooltip title={"Voltar"}>
                <IconButtonStyled
                  onClick={goBack}
                  size="small"
                  children={<ArrowBack style={{ fontSize: 26 }} />}
                />
              </Tooltip>
            </Grid>
          </Grid>
        }
      />
      <Loading open={loading || openFinanceConciliationLoading} />
      <Container
        style={{
          maxWidth: "100vw",
          marginTop: 80,
          paddingLeft: "1vw",
          paddingRight: "1vw",
        }}
      >
        <Card
          fullWidth
          style={{
            zIndex: 11,
            width: "97vw",
            position: "fixed",
          }}
        >
          <Grid container spacing={2}>
            <Grid item md={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Conta Bancária"
                value={bankAccount}
                onChange={handleSetBankAccount}
                optionsList={bankAccountsList}
                descriptionField="apelido"
                disabled={historicVisualization || hasBank}
              />
            </Grid>
            <Grid item md={2}>
              <TextFieldErp
                label="Data Inicial"
                type="date"
                size="small"
                disabled={conciliationType !== "openFinance"}
                value={initialDate}
                onChange={(e) => setInitialDate(e.target.value)}
                onBlur={() => {
                  handleOpenFinanceConciliation();
                }}
              />
            </Grid>
            <Grid item md={2}>
              <TextFieldErp
                label="Data Final"
                type="date"
                size="small"
                disabled={conciliationType !== "openFinance"}
                value={finalDate}
                onChange={(e) => setFinalDate(e.target.value)}
                onBlur={() => {
                  handleOpenFinanceConciliation();
                }}
              />
            </Grid>
            <Grid item md={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Extrato Bancário"
                value={bankExtract}
                setValue={setBankExtract}
                optionsList={bankExtractFilterList}
                onChange={(e) =>
                  handleChangeSelect(e, setBankExtract, bankExtractFilterList)
                }
                descriptionField="label"
                variant="filled"
              />
            </Grid>
            <Grid item md={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Status"
                value={status}
                setValue={setStatus}
                optionsList={statusesList}
                onChange={(e) => handleChangeSelect(e, setStatus, statusesList)}
                descriptionField="label"
                variant="filled"
              />
            </Grid>
            {/* <Grid item md={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Gestão fácil"
                value={movimentations}
                setValue={setMovimentations}
                optionsList={erpList}
                onChange={(e) =>
                  handleChangeSelect(e, setMovimentations, erpList)
                }
                descriptionField="label"
                variant="filled"
              />
            </Grid> */}
            <Grid item md={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Categorias"
                value={category}
                setValue={setCategory}
                optionsList={categoriesList}
                onChange={(e) =>
                  handleChangeSelect(e, setCategory, categoriesList)
                }
                descriptionField="label"
                variant="filled"
              />
            </Grid>
            <Grid item container md={12} justifyContent="space-around">
              {indicators.map((indicator, i) => (
                <Indicator
                  label={indicator.label}
                  counterState={indicator.counterState}
                  key={i}
                />
              ))}
            </Grid>
          </Grid>
        </Card>

        <Separator ref={separatorRef} />

        <GridTitleSeparator container justifyContent="space-between">
          <Grid item md={4} xs={5}>
            <span>LANÇAMENTOS EXTRATO</span>
          </Grid>

          <Grid item md={4} xs={5}>
            <span>LANÇAMENTOS SISTEMA</span>
          </Grid>
        </GridTitleSeparator>

        <ExtractContainter>
          {filterTransactions(transactions, FILTERS)
            .map((item) => (
              <ConciliationRow
                key={item.id}
                data={item}
                handleActions={handleItemActions}
              />
            ))
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .sort((a, b) => {
              if (
                a.props?.data?.status !== "conciliado" &&
                b.props?.data?.status === "conciliado"
              ) {
                return -1;
              }

              if (
                a.props?.data?.status === "conciliado" &&
                b.props?.data?.status !== "conciliado"
              ) {
                return 1;
              }

              return 0;
            })
            .slice(
              pageProp === 1 ? 0 : ROWS_PER_PAGE * pageProp - ROWS_PER_PAGE,
              ROWS_PER_PAGE * pageProp
            )}
        </ExtractContainter>
        <PaginationContainer>
          <Pagination
            count={Math.ceil(
              filterTransactions(transactions, FILTERS).length / ROWS_PER_PAGE
            )}
            onChange={handlePaginationChange}
          />
        </PaginationContainer>
        <Container style={{ margin: "20px 0" }}>
          <Grid container justifyContent="flex-end">
            <Btn
              bgcolor="green"
              hovercolor="darkgreen"
              label="Realizar conciliações"
              disabled={
                (!indicators[1].counterState && !indicators[4].counterState) ||
                historicVisualization
              }
              onClick={() => doConciliation()}
            />
          </Grid>
        </Container>
      </Container>
    </>
  );
};

const Indicator = ({ label = "", counterState = 0 }) => (
  <Grid item>
    <IndicatorStyled>
      <b>{counterState}</b>
      <span>{label}</span>
    </IndicatorStyled>
  </Grid>
);

export const ValueSpan = ({
  value,
  reverse = false,
  margin = false,
  fontSize = 18,
}) => {
  var color;

  if (reverse) {
    color = parseFloat(value) < 0 ? "#39A388" : "#FA8072";
  } else color = parseFloat(value) > 0 ? "#39A388" : "#FA8072";

  return (
    <CustomDiv margin={margin}>
      {color === "#39A388" ? (
        <ArrowUpward style={{ color }} />
      ) : (
        <ArrowDownward style={{ color }} />
      )}
      <span style={{ color, fontSize: fontSize, fontWeight: "bold" }}>
        {MaskService.toMask("decimal", parseFloat(value).toFixed(2))}
      </span>
    </CustomDiv>
  );
};

const CardOFX = ({
  data,
  handleOpenSearchModal = () => {},
  handleOpenTitleLogsModal = () => {},
}) => {
  const { historicVisualization } = useContext(ConciliacaoBancariaContext);
  return (
    <CardBody style={{ zIndex: "10", backgroundColor: "rgba(0,0,0,0.05)" }}>
      <div className="Row">
        <span className="Date">
          {formatDate({
            date: data.date,
            separator: "/",
          })}
        </span>
        <ValueSpan value={data.amount} />
      </div>
      <div className="Row">
        <span className="History">{data.memo}</span>
      </div>
      <div className="Row">
        <div className="Icon Row" style={{ marginBottom: 0 }}>
          {!["naoconciliado", "ignorado", "pendente", "conciliado"].includes(
            data.status
          ) &&
            !historicVisualization && (
              <Tooltip title="Adicionar movimentações">
                <div style={{ marginRight: 10 }}>
                  <SimpleMenuErp
                    icon={<Search />}
                    actions={[
                      {
                        label: "Pesquisar lançamento",
                        onClick: () => handleOpenSearchModal(),
                      },
                    ]}
                  />
                </div>
              </Tooltip>
            )}

          <div>
            <Tooltip title={"Logs"}>
              <IconButtonStyled
                onClick={handleOpenTitleLogsModal}
                size="small"
                children={<History />}
              />
            </Tooltip>
          </div>
        </div>

        {data.status && (
          <StatusBar
            color={STATUS[data.status || "naoconciliado"].color}
            children={STATUS[data.status || "naoconciliado"].title}
          />
        )}
      </div>
    </CardBody>
  );
};

const CardERP = ({
  content = [],
  handleOpenVisualizationModal = () => {},
  type,
  visualizationOnly = false,
  conciliated = false,
}) => {
  const summedValue = content.reduce((acc, current) => {
    return (
      acc + parseFloat(current.valor ?? current.value ?? current.valordocto)
    );
  }, 0);

  const summedFees = content.reduce((acc, current) => {
    return acc + parseFloat(current.fees || 0.0);
  }, 0);

  const summedFines = content.reduce((acc, current) => {
    return acc + parseFloat(current.fine || 0.0);
  }, 0);

  const summedAbatement = content.reduce((acc, current) => {
    return acc + parseFloat(current.abatement || 0.0);
  }, 0);

  return (
    <>
      <CardBody>
        <div className="Row">
          <ValueSpan
            value={
              type === "CREDIT"
                ? summedValue + summedFees + summedFines - summedAbatement
                : (summedValue + summedFees + summedFines - summedAbatement) *
                  -1
            }
          />
        </div>

        {content.length > 1 ? (
          <>
            <div className="Row">
              <span className="History">
                Lançamentos Diversos - verificar detalhes na edição das
                movimentações!
              </span>
            </div>
            <div className="Row FlexEnd">
              {content && (
                <div style={{ marginRight: 10 }}>
                  <Tooltip
                    title={`${
                      visualizationOnly || conciliated ? "Visualizar" : "Editar"
                    } movimentações selecionadas`}
                  >
                    <IconButtonStyled
                      onClick={handleOpenVisualizationModal}
                      size="small"
                      children={
                        visualizationOnly || conciliated ? (
                          <Visibility />
                        ) : (
                          <Receipt />
                        )
                      }
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            {(content[0].numerodocto || content[0].numberDocto) && (
              <div className="Row ">
                <span className="History">
                  <span className="Title">N° Documento: </span>
                  {content[0].numerodocto || content[0].numberDocto}
                </span>
              </div>
            )}

            {!content[0].numerodocto && !content[0].numberDocto && (
              <div className="Row ">
                <span className="History">
                  <span className="Title">N° Movimentação: </span>
                  {content[0].id || content[0].id}
                </span>
              </div>
            )}

            {(content[0].cliente ||
              content[0].fornecedor ||
              content[0].funcionario ||
              content[0].vendedor ||
              content[0].parceiro_comercial ||
              content[0].participant) && (
              <div className="Row">
                <span className="History">
                  <span className="Title">Participante: </span>
                  {content[0].cliente?.razao ||
                    content[0].fornecedor?.razao ||
                    content[0].funcionario?.nome ||
                    content[0].vendedor?.nomevendedor ||
                    content[0].parceiro_comercial?.nome ||
                    content[0].participant}
                </span>
              </div>
            )}

            {(content[0].description || content[0].historico) && (
              <div className="Row NoMargin">
                <span className="History">
                  <span className="Title">Descrição: </span>
                  {content[0].description || content[0].historico}
                </span>
              </div>
            )}

            {(content[0].date || content[0].data) && (
              <div className="Row NoMargin">
                <span className="History">
                  <span className="Title">Data: </span>
                  {content[0].date
                    ? new Date(content[0].date).toLocaleDateString("pt-BR")
                    : new Date(content[0].data).toLocaleDateString("pt-BR")}
                </span>
              </div>
            )}

            <div className="Row FlexEnd">
              {content && (
                <div style={{ marginRight: 10 }}>
                  <Tooltip
                    title={`${
                      visualizationOnly || conciliated ? "Visualizar" : "Editar"
                    } movimentações selecionadas`}
                  >
                    <IconButtonStyled
                      onClick={handleOpenVisualizationModal}
                      size="small"
                      children={
                        visualizationOnly || conciliated ? (
                          <Visibility />
                        ) : (
                          <Receipt />
                        )
                      }
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </>
        )}
      </CardBody>
    </>
  );
};

const ConciliationRow = ({ data, handleActions = async () => {} }) => {
  const { bankAccount, historicVisualization, fileId } = useContext(
    ConciliacaoBancariaContext
  );

  const [itemData, setItemData] = useState(data);
  const [modalSearchOpen, setModalSearchOpen] = useState(false);
  const [modalTitleLogsOpen, setModalTitleLogsOpen] = useState(false);
  const [modalVisualizationOpen, setModalVisualizationOpen] = useState(false);
  const [addPayments, setAddPayments] = useState(false);
  const [pendingsCopy, setPendingsCopy] = useState([]);
  const [inProp, setInProp] = useState(false);

  const handleChangeStatus = async (status) => {
    if (!bankAccount)
      return notify(
        "Selecione uma conta bancária antes de continuar",
        true,
        "warning"
      );

    await callAction("changeStatus", status, {
      arquivo_ofx_id: fileId,
      extrato_transacao_id: itemData.id,
      status: status,
      movimentacao_contas: itemData?.pending?.map((e) => ({
        ...e,
      })),
    });

    setInProp(false);
  };

  const handleOpenSearchModal = () => {
    if (!bankAccount)
      return notify(
        "Selecione uma conta bancária antes de continuar",
        true,
        "warning"
      );
    setModalSearchOpen(true);
  };

  const handleOpenTitleLogsModal = () => {
    if (!bankAccount)
      return notify(
        "Selecione uma conta bancária antes de continuar",
        true,
        "warning"
      );
    setModalTitleLogsOpen(true);
  };

  const handleModalTitleLogsClose = () => {
    setModalTitleLogsOpen(false);
  };

  const handleOpenVisualizationModal = () => {
    if (!bankAccount)
      return notify(
        "Selecione uma conta bancária antes de continuar",
        true,
        "warning"
      );
    setModalVisualizationOpen(true);
  };

  const callAction = async (action, content, body) => {
    await handleActions({ action, content, body }, itemData.id, setItemData);
  };

  const visualizationOnly =
    itemData.status === "pendente" || itemData.status === "ignorado";

  const conciliated = itemData.status === "conciliado";

  return (
    <ContainerRow>
      {modalSearchOpen && (
        <ModalSearch
          open={modalSearchOpen}
          setModalOpen={setModalSearchOpen}
          suggestions={itemData.suggestions}
          callHandleActions={(content) => callAction("edit", content)}
          pending={itemData.pending}
          transactionType={itemData.type}
          transactionAmount={Math.abs(itemData.amount) || 0}
          transactionDate={itemData.date}
          transactionMemo={itemData.memo}
        />
      )}

      {modalVisualizationOpen && (
        <ModalVisualization
          open={modalVisualizationOpen}
          setModalOpen={setModalVisualizationOpen}
          content={itemData.pending}
          callAction={(content) => callAction("edit", content)}
          visualizationOnly={visualizationOnly}
          transactionAmount={Math.abs(itemData.amount) || 0}
          type={itemData.type}
          transactionDate={itemData.date}
          transactionMemo={itemData.memo}
          extrato_transacao_id={itemData.id}
          conciliatedStatus={conciliated}
          addPayments={addPayments}
          setAddPayments={setAddPayments}
          pendingsCopy={pendingsCopy}
          setPendingsCopy={setPendingsCopy}
          handleChangeStatus={handleChangeStatus}
        />
      )}

      {modalTitleLogsOpen && (
        <ModalLogs
          open={modalTitleLogsOpen}
          handleClose={handleModalTitleLogsClose}
          findId={itemData.id || null}
          titleLog={itemData.memo || ""}
          handleGetLogs={(idLog) =>
            findTitleLog({ extrato_transacao_id: idLog })
          }
        />
      )}

      <CardOFX
        data={itemData}
        handleOpenSearchModal={handleOpenSearchModal}
        handleOpenTitleLogsModal={handleOpenTitleLogsModal}
      />
      {!historicVisualization && !itemData.conciliated && (
        <ButtonsGenerator
          status={itemData.status}
          handleOpenSearchModal={handleOpenSearchModal}
          handleOpenVisualizationModal={handleOpenVisualizationModal}
          pending={itemData.pending || []}
          transactionAmount={itemData.amount || 0}
          transactionType={itemData.type}
          transactionDate={itemData.date}
          setModalVisualizationOpen={setModalVisualizationOpen}
          setAddPayments={setAddPayments}
          setPendingsCopy={setPendingsCopy}
          handleChangeStatus={handleChangeStatus}
          inProp={inProp}
          setInProp={setInProp}
        />
      )}

      {!!itemData.pending?.length && (
        <CardERP
          type={itemData.type}
          handleOpenSearchModal={handleOpenSearchModal}
          handleOpenVisualizationModal={handleOpenVisualizationModal}
          content={itemData.pending}
          visualizationOnly={visualizationOnly}
          conciliated={conciliated}
        />
      )}
    </ContainerRow>
  );
};

const ButtonsGenerator = ({
  status,
  handleOpenSearchModal = () => {},
  handleOpenVisualizationModal = () => {},
  pending = [],
  transactionAmount = 0,
  transactionType = "",
  transactionDate,
  setModalVisualizationOpen,
  setAddPayments,
  setPendingsCopy,
  handleChangeStatus = async () => {},
  inProp,
  setInProp,
}) => {
  const { alertCategory, setMismatchValue, setNeedMismatchValueFullfill } =
    useContext(ConciliacaoBancariaContext);

  const [modalMismatchValueOpen, setModalMismatchValueOpen] = useState(false);

  const handleOpenMismatchValueModal = () => {
    setModalMismatchValueOpen(true);
  };

  // Colocar uma condição, ou vai gerar o 'Conciliar' com o 'ignorar'
  // ou vai gerar o 'desfazer conciliacao';
  const [showAlertCategory, setShowAlertCategory] = useState(
    !!(
      alertCategory === "1" &&
      !!pending?.filter((title) => !title.category?.length).length
    )
  );

  useEffect(() => {
    if (inProp) return;
    setTimeout(() => {
      setInProp(true);
    }, 500);
  }, [inProp, setInProp]);

  const summedValue = pending.reduce((acc, current) => {
    return (
      acc + parseFloat(current.valor || current.value || current.valordocto)
    );
  }, 0);

  let summedFees = pending.reduce((acc, current) => {
    return acc + parseFloat(current.fees || 0.0);
  }, 0);

  let summedFines = pending.reduce((acc, current) => {
    return acc + parseFloat(current.fine || 0.0);
  }, 0);

  let summedAbatement = pending.reduce((acc, current) => {
    return acc + parseFloat(current.abatement || 0.0);
  }, 0);

  const equalValue =
    parseFloat(Math.abs(transactionAmount)).toFixed(2) ===
    parseFloat(
      summedValue + summedFees + summedFines - summedAbatement
    ).toFixed(2);

  const totalConciliationValue =
    transactionType === "CREDIT"
      ? parseFloat(
          parseFloat(
            summedValue + summedFees + summedFines - summedAbatement
          ).toFixed(2)
        )
      : parseFloat(
          parseFloat(
            (summedValue + summedFees + summedFines - summedAbatement) * -1
          ).toFixed(2)
        );

  const showSearchButtons = !pending.length;

  const handleCreditTitleGeneration = async () => {
    let mismatch =
      transactionType === "CREDIT"
        ? (transactionAmount - totalConciliationValue) * -1
        : transactionAmount - totalConciliationValue;

    if (mismatch) {
      setNeedMismatchValueFullfill(false);
      setMismatchValue(parseFloat(mismatch).toFixed(2));
      handleOpenMismatchValueModal();
    } else {
      handleChangeStatus("pendente");
    }
  };

  useEffect(() => {
    setShowAlertCategory(
      !!(
        alertCategory === "1" &&
        !!pending?.filter((title) => !title.category?.length).length
      )
    );
  }, [alertCategory, pending]);

  return (
    <>
      {modalMismatchValueOpen && (
        <ModalMismatchValue
          open={modalMismatchValueOpen}
          setModalOpen={setModalMismatchValueOpen}
          transactionAmount={transactionAmount}
          pending={pending}
          setModalVisualizationOpen={setModalVisualizationOpen}
          setAddPayments={setAddPayments}
          transactionType={transactionType}
          transactionDateString={transactionDate}
          handleChangeStatus={handleChangeStatus}
          setPendingsCopy={setPendingsCopy}
        />
      )}
      {
        <ButtonsContainer style={{ zIndex: "5" }}>
          <div>
            <Slide in={inProp} direction="right">
              {status === "naoconfirmado" ? (
                <ButtonsContainer>
                  {(!equalValue || showAlertCategory) && (
                    <Tooltip
                      title="Divergência na Conciliação!"
                      placement="top"
                    >
                      <div>
                        <InfoButton
                          style={{ fontSize: "2.0rem" }}
                          onClick={handleOpenVisualizationModal}
                        />
                      </div>
                    </Tooltip>
                  )}
                  <Btn
                    onClick={handleCreditTitleGeneration}
                    label="Marcar para Conciliar"
                    bgcolor="green"
                    hovercolor="darkgreen"
                  />
                  <IgnoreButton onClick={() => handleChangeStatus("ignorado")}>
                    Ignorar
                  </IgnoreButton>
                </ButtonsContainer>
              ) : status === "naoconciliado" ? (
                <div>
                  <IgnoreButton onClick={() => handleChangeStatus("ignorado")}>
                    Ignorar
                  </IgnoreButton>
                </div>
              ) : (
                <div>
                  <Btn
                    onClick={
                      status === "ignorado"
                        ? () => handleChangeStatus("desfazer")
                        : () => handleChangeStatus("naoconfirmado")
                    }
                    label={status === "ignorado" ? "Desfazer" : "Desmarcar"}
                    bgcolor="red"
                    hovercolor="darkred"
                  />
                </div>
              )}
            </Slide>
          </div>
        </ButtonsContainer>
      }

      {showSearchButtons && (
        <ButtonsContainer custom>
          <Btn
            onClick={() => {
              handleOpenSearchModal();
            }}
            label="Adicionar lançamentos"
            bgcolor="primary"
            hovercolor="tertiary"
          />
        </ButtonsContainer>
      )}
    </>
  );
};

const ConciliacaoBancaria = ({ ...props }) => {
  return (
    <ConciliacaoBancariaContextProvider>
      <View {...props} />
    </ConciliacaoBancariaContextProvider>
  );
};

export default ConciliacaoBancaria;
